import React, { Component } from 'react'
import classnames from 'classnames'
import StreamInfo from '../../common/stream-info/stream-info'
import SelectBar from '../../common/select-bar/select-bar'
import TagBar from '../../common/tag-bar/tag-bar'
import * as api from '../../../api'
import UserBar from '../../common/user-bar/user-bar'
import Cookies from 'universal-cookie'
import BanBar from '../../common/ban-bar/ban-bar'

const scope = 'MainPage'
class MainPage extends Component {
  constructor(props) {
    super(props)
    const prefs = new Cookies().get('preferences') || {
      showAllStreams: false,
      sortOption: 2,
      includedTags: [],
      excludedTags: [],
      hiddenUsers: [],
    }
    this.state = {
      cache: Date.now(),
      showAllStreams: !!prefs.showAllStreams,
      sortOption: Math.min(3, Math.max(0, prefs.sortOption)),
      includedTags: Array.isArray(prefs.includedTags) ? prefs.includedTags : [],
      excludedTags: Array.isArray(prefs.excludedTags) ? prefs.excludedTags : [],
      hiddenUsers: Array.isArray(prefs.hiddenUsers) ? prefs.hiddenUsers : [],
    }
    this.cache = this.intervalID = undefined
    this.getStreams = this.getStreams.bind(this)
    this.getTags = this.getTags.bind(this)
    this.translateTags = this.translateTags.bind(this)
    this.formatStreamInformation = this.formatStreamInformation.bind(this)
    this.logOut = this.logOut.bind(this)
    this.removeHiddenUser = this.removeHiddenUser.bind(this)
  }

  componentDidMount() {
    this.getStreams(this.getTags)
  }

  componentDidUpdate() {
    const { showAllStreams, sortOption, includedTags, excludedTags, hiddenUsers } = this.state
    new Cookies().set(
      'preferences',
      {
        showAllStreams,
        sortOption,
        includedTags,
        excludedTags,
        hiddenUsers,
      },
      {
        maxAge: 2592000,
      },
    )
  }

  componentWillUnmount() {
    if (this.intervalID) {
      clearTimeout(this.intervalID)
    }
  }

  getStreams(callback = () => {}) {
    api.getStreams().then(streams => {
      this.setState({ streams }, callback)
    })
  }

  getTags(callback = () => {}) {
    api.getTags().then(tags => this.setState({ tags }, callback))
  }

  logOut() {
    api.logOut().then(this.props.history.go(0))
  }

  translateTags(tags) {
    if (!this.state.tags) {
      return undefined
    }
    return !tags || !Array.isArray(tags)
      ? []
      : tags.map(tag => {
          const tagInfo = this.state.tags.find(info => info.id === tag)
          if (!tagInfo) {
            console.log('[TAGS] Unknown tag: ', tag)
          }
          return { id: tag, text: tagInfo ? tagInfo.name : 'Unknown Tag' }
        })
  }

  translateHiddenUsers() {
    if (!this.state.hiddenUsers || !this.state.streams) {
      return undefined
    }
    const users = this.state.hiddenUsers.map(userId => {
      const user = this.state.streams.find(stream => stream.id === userId)
      return {
        // icon: <i className='fas fa-user' />,
        title: `Show ${user.name}`,
        name: user.name,
        id: userId,
      }
    })
    return users
  }

  removeHiddenUser(userId) {
    this.setState({
      hiddenUsers: this.state.hiddenUsers.filter(id => id !== userId),
    })
  }

  formatStreamInformation(stream) {
    const { includedTags, excludedTags } = this.state
    if (!this.state.tags) {
      const { tags, ...rest } = stream
      return { rest, includedTags, excludedTags }
    }
    const clean = {
      ...stream,
      excludedTags,
      includedTags,
      tags: this.translateTags(stream.tags),
    }
    return clean
  }

  render() {
    const { className, user } = this.props
    const liveOptions = [
      {
        text: 'Live Streams',
        value: 0,
      },
      {
        text: 'All Streams',
        value: 1,
      },
    ]

    const sortBy = (a, b, numeric = false, reverse = false) =>
      (reverse ? -1 : 1) *
      (a || (numeric ? '0' : ''))
        .toString()
        .localeCompare((b || (numeric ? '0' : '')).toString(), undefined, { numeric })

    const featuredSort = (a, b) => sortBy(a.featured, b.featured, true, true)
    const nameSort = (a, b) => sortBy(a.name, b.name)
    const gameSort = (a, b) => sortBy(a.game, b.game)
    const viewerSort = (a, b) => sortBy(a.viewer_count, b.viewer_count, true)
    const timeSort = (a, b) => sortBy(a.time, b.time, true)

    const sortOptions = [
      {
        icon: <i className='fas fa-id-card-alt' />,
        text: 'Name',
        value: 0,
        title: 'Sort by Name',
      },
      {
        icon: <i className='fas fa-gamepad' />,
        text: 'Game',
        value: 1,
        sortFunction: gameSort,
        title: 'Sort by Game',
      },
      {
        icon: <i className='fa fa-user' />,
        text: 'Viewers',
        value: 2,
        sortFunction: viewerSort,
        title: 'Sort by Viewer Count',
      },
      {
        icon: <i className='far fa-clock' />,
        text: 'Time Live',
        value: 3,
        sortFunction: timeSort,
        title: 'Sort by Time Live',
      },
    ]

    const sort = (sortFunction, a, b) =>
      featuredSort(a, b) || (sortFunction ? sortFunction(a, b) : undefined) || nameSort(a, b)

    const { showAllStreams, sortOption, streams, hiddenUsers, includedTags, excludedTags, cache } = this.state

    const removeFromArray = (arr, element) => {
      const index = arr.indexOf(element)
      if (index > -1) {
        arr.splice(index, 1)
      }
    }

    const onSaveOptions = (id, userIgnore, tagIncludes, tagExcludes) => {
      const newHiddenUsers = [...this.state.hiddenUsers]
      if (userIgnore && !newHiddenUsers.includes(id)) {
        newHiddenUsers.push(id)
      }
      const newIncludedTags = [...this.state.includedTags]
      tagIncludes.forEach(id => {
        if (newIncludedTags.includes(id)) {
          removeFromArray(newIncludedTags, id)
        } else {
          newIncludedTags.push(id)
        }
      })
      tagExcludes.forEach(id => removeFromArray(newIncludedTags, id))
      const newExcludedTags = [...this.state.excludedTags]
      tagExcludes.forEach(id => {
        if (newExcludedTags.includes(id)) {
          removeFromArray(newExcludedTags, id)
        } else {
          newExcludedTags.push(id)
        }
      })
      tagIncludes.forEach(id => removeFromArray(newExcludedTags, id))
      this.setState({
        hiddenUsers: newHiddenUsers,
        includedTags: newIncludedTags,
        excludedTags: newExcludedTags,
      })
    }

    const onRemoveIncludedTag = id => {
      const newIncludedTags = [...this.state.includedTags]
      removeFromArray(newIncludedTags, id)
      this.setState({
        includedTags: newIncludedTags,
      })
    }

    const onRemoveExcludedTag = id => {
      const newExcludedTags = [...this.state.excludedTags]
      removeFromArray(newExcludedTags, id)
      this.setState({
        excludedTags: newExcludedTags,
      })
    }

    const showUser = (id, tags) => {
      const userHidden = hiddenUsers.includes(id)
      const hasRequiredTag = includedTags.length === 0 || includedTags.filter(tagID => tags.includes(tagID)).length > 0
      const hasExcludedTag = excludedTags.some(tagID => tags.includes(tagID))
      return !userHidden && hasRequiredTag && !hasExcludedTag
    }

    return (
      <div className={classnames(scope, className)}>
        <div className={classnames(`${scope}-Header`)}>
          {<UserBar user={user} onLogOut={this.logOut} />}
          <div className={classnames(`${scope}-Filters`)}>
            <div className={classnames(`${scope}-Selectors`)}>
              {user && user.level > 0 ? (
                <SelectBar
                  inline
                  title='Show:'
                  options={liveOptions}
                  value={showAllStreams ? 1 : 0}
                  onSelect={value => this.setState({ showAllStreams: value === 1 })}
                />
              ) : null}
              <SelectBar
                inline
                title='Sort:'
                options={sortOptions}
                value={sortOption}
                onSelect={value => this.setState({ sortOption: value })}
              />
            </div>
            <div>
              {includedTags.length > 0 && this.state.tags ? (
                <TagBar onRemove={onRemoveIncludedTag} title='Required Tags:' tags={this.translateTags(includedTags)} />
              ) : null}
            </div>
            <div>
              {excludedTags.length > 0 && this.state.tags ? (
                <TagBar onRemove={onRemoveExcludedTag} title='Excluded Tags:' tags={this.translateTags(excludedTags)} />
              ) : null}
            </div>
          </div>
        </div>
        {streams && (
          <div className={`${scope}-StreamInfoContainer`}>
            {streams
              .filter(stream => (stream.online && stream.showStream) || (user && user.level > 0 && showAllStreams))
              .sort((a, b) => sort(sortOptions[sortOption].sortFunction, a, b))
              .map(stream =>
                showAllStreams || showUser(stream.id, stream.tags || []) ? (
                  <StreamInfo
                    cache={cache}
                    blocked={!showUser(stream.id, stream.tags || [])}
                    onSaveOptions={onSaveOptions}
                    key={stream.login}
                    featuredTitle={stream.featured && `${this.props.config.siteName} Partner Streamer`}
                    {...this.formatStreamInformation(stream)}
                  />
                ) : null,
              )}
          </div>
        )}
        <div className={classnames(`${scope}-Bans`)}>
          {hiddenUsers && hiddenUsers.length > 0 && streams && (
            <BanBar
              title='Hidden Users:'
              options={this.translateHiddenUsers().sort(nameSort)}
              onSelect={this.removeHiddenUser}
            />
          )}
        </div>
      </div>
    )
  }
}

export default MainPage



// WEBPACK FOOTER //
// ./src/components/views/main-page/main-page.jsx